// DEV-ONLY (Juni 2026): Bühne „Wiedervorlage / Wiederholung / Ampel" — Crop B „Entlastung".
// KEINE /abo-Bühne. Reine Entscheidungs-Vorschau (Desktop + Mobile) für Crop, Größen-
// verhältnis und Chris-Position. Screenshot = echter Produktbeweis (Owner-Dashboard,
// Christian Lumpe), nur zugeschnitten (kein roter „überfällig"-Header), inhaltlich unverändert.
// Wird nach Betreiber-Freigabe entfernt bzw. in die echte /abo-Bühne überführt.

import { DESKTOP as IMG_DESKTOP, MOBILE_CARDS, MOBILE_ROWS, CHRIS } from "./_wvData";

const HEADLINE = "Einmal eingerichtet. Beim nächsten Mal kümmert sich Chris wieder darum.";
const CHRIS_TEXT =
  "Ich lege die nächste Wiederholung an, bringe sie wieder zu Ihrem Mitarbeiter und behalte den Stand für Sie im Blick.";
const BENEFIT = "Keine Kalenderlisten. Kein erneutes Anlegen.";
const MAIL =
  "Auf Wunsch informiert CLartext den Mitarbeiter zusätzlich per E-Mail, sobald die Aufgabe wieder ansteht.";
const MAIL_FOOT = "E-Mail-Benachrichtigung muss vom Mitarbeiter aktiviert sein.";

// Helle, freundliche CLARTEXT-Farbwelt (Hero-/B3-orientiert) — Sky→Mint-Lichtfläche,
// kein reines Weiß. Screenshot, Ampelfarben und Chris bleiben die visuellen Stars.
const PLATE = {
  background:
    "linear-gradient(158deg, #e8f3fb 0%, #e9f6f1 52%, #f5fbf9 100%)",
  position: "relative",
  overflow: "hidden",
};
const GRAIN = {
  position: "absolute",
  inset: 0,
  background:
    "radial-gradient(70% 60% at 12% -8%, rgba(255,255,255,.75) 0%, rgba(255,255,255,0) 60%)",
  pointerEvents: "none",
};

function Bubble({ children, testId, style }) {
  return (
    <div
      data-testid={testId}
      style={{
        position: "relative",
        background: "#ffffff",
        color: "#12385f",
        borderRadius: 18,
        padding: "16px 20px",
        border: "1px solid #e6edf5",
        boxShadow: "0 18px 44px rgba(15,40,80,.16)",
        fontWeight: 600,
        lineHeight: 1.45,
        ...style,
      }}
    >
      {children}
    </div>
  );
}

function ShotFrame({ src, alt, testId, style }) {
  return (
    <div
      style={{
        borderRadius: 22,
        overflow: "hidden",
        border: "1px solid #e2e8f0",
        boxShadow: "0 26px 60px rgba(15,40,80,.16)",
        background: "#ffffff",
        ...style,
      }}
    >
      <img
        src={src}
        alt={alt}
        data-testid={testId}
        loading="eager"
        decoding="sync"
        style={{ width: "100%", height: "auto", display: "block" }}
      />
    </div>
  );
}

export default function AboWiedervorlageDev() {
  const view =
    typeof window !== "undefined"
      ? new URLSearchParams(window.location.search).get("view")
      : null;
  const showDesktop = view !== "mobile";
  const showMobile = view !== "desktop";
  return (
    <div
      data-testid="abo-wv-dev"
      style={{
        background: "#eef3f8",
        minHeight: "100vh",
        fontFamily: "system-ui,-apple-system,Segoe UI,Roboto,sans-serif",
        color: "#334155",
        paddingBottom: 80,
      }}
    >
      {/* Dev-Kopf */}
      <div style={{ maxWidth: 1240, margin: "0 auto", padding: "36px 24px 8px" }}>
        <p
          style={{
            textTransform: "uppercase",
            letterSpacing: ".22em",
            fontSize: 12,
            color: "#0e7490",
            fontWeight: 800,
            margin: 0,
          }}
        >
          Dev-Vorschau · Wiedervorlage / Wiederholung / Ampel · Crop B „Entlastung"
        </p>
        <p style={{ color: "#475569", fontSize: 13, margin: "8px 0 0", maxWidth: 820 }}>
          Kein /abo-Einbau. Echter Produktbeweis (Owner-Dashboard), nur zugeschnitten — ohne
          roten „überfällig"-Header. Fokus: Ampel, „268 erledigt" und sichtbare Fälligkeiten.
        </p>
      </div>

      {showDesktop && (
      <>
      {/* ---------- DESKTOP-BÜHNE ---------- */}
      <div style={{ maxWidth: 1240, margin: "18px auto 0", padding: "0 24px" }}>
        <p style={devLabel}>DESKTOP-BÜHNE</p>
      </div>
      <section
        data-testid="wv-desktop-stage"
        style={{ ...PLATE, maxWidth: 1240, margin: "0 auto", borderRadius: 28, padding: "56px 56px 44px" }}
      >
        <div style={GRAIN} />
        <div style={{ position: "relative" }}>
          <p style={kicker}>Wiederholungen laufen weiter</p>
          <h2 style={headlineDesk} data-testid="wv-desktop-headline">
            {HEADLINE}
          </h2>

          <div
            style={{
              marginTop: 36,
              display: "grid",
              gridTemplateColumns: "minmax(0, 1.55fr) minmax(0, 1fr)",
              gap: 8,
              alignItems: "center",
            }}
          >
            {/* Beweisbild groß */}
            <ShotFrame
              src={IMG_DESKTOP}
              alt="CLartext Unterweisungsübersicht: Handlungsbedarf, Bald fällig, 268 Erledigt und fällige Aufgaben."
              testId="wv-desktop-shot"
            />

            {/* Chris groß + Sprechblase */}
            <div style={{ position: "relative", alignSelf: "stretch", minHeight: 460 }}>
              <Bubble
                testId="wv-desktop-bubble"
                style={{ position: "absolute", top: 8, left: 12, right: 8, zIndex: 3, fontSize: 17 }}
              >
                {CHRIS_TEXT}
              </Bubble>
              <img
                src={CHRIS}
                alt=""
                aria-hidden="true"
                data-testid="wv-desktop-chris"
                style={{
                  position: "absolute",
                  bottom: -44,
                  right: -24,
                  height: 500,
                  width: "auto",
                  filter: "drop-shadow(0 26px 40px rgba(15,40,80,.22))",
                }}
              />
            </div>
          </div>

          {/* Nutzen + Mail */}
          <div style={{ position: "relative", marginTop: 28, maxWidth: 720 }}>
            <p style={benefitStyle} data-testid="wv-desktop-benefit">
              {BENEFIT}
            </p>
            <p style={mailStyle} data-testid="wv-desktop-mail">
              {MAIL}
              <span style={footStyle}> {MAIL_FOOT}</span>
            </p>
          </div>
        </div>
      </section>
      </>)}

      {showMobile && (
      <>
      {/* ---------- MOBILE-BÜHNE (390px) ---------- */}
      <div style={{ maxWidth: 1240, margin: "56px auto 0", padding: "0 24px" }}>
        <p style={devLabel}>MOBILE-BÜHNE · 390&nbsp;px (eigener Crop, nicht verkleinerter Desktop)</p>
      </div>
      <div style={{ display: "flex", justifyContent: "center", marginTop: 4 }}>
        <section
          data-testid="wv-mobile-stage"
          style={{ ...PLATE, width: 390, borderRadius: 30, padding: "30px 22px 30px" }}
        >
          <div style={GRAIN} />
          <div style={{ position: "relative" }}>
            <p style={{ ...kicker, fontSize: 11 }}>Wiederholungen laufen weiter</p>
            <h2 style={headlineMob} data-testid="wv-mobile-headline">
              {HEADLINE}
            </h2>
            <div style={{ marginTop: 18, display: "flex", flexDirection: "column", gap: 10 }}>
              <ShotFrame
                src={MOBILE_CARDS}
                alt="CLartext Ampel: Handlungsbedarf 17, Bald fällig 0, Erledigt 268."
                testId="wv-mobile-shot-cards"
              />
              <ShotFrame
                src={MOBILE_ROWS}
                alt="Fällige Aufgaben mit Datum."
                testId="wv-mobile-shot-rows"
              />
            </div>
            <div style={{ position: "relative", marginTop: 10, display: "flex", alignItems: "flex-start", gap: 6 }}>
              <img
                src={CHRIS}
                alt=""
                aria-hidden="true"
                data-testid="wv-mobile-chris"
                style={{ height: 210, width: "auto", flex: "none", marginLeft: -10, filter: "drop-shadow(0 16px 26px rgba(15,40,80,.2))" }}
              />
              <Bubble testId="wv-mobile-bubble" style={{ marginTop: 24, fontSize: 14 }}>
                {CHRIS_TEXT}
              </Bubble>
            </div>
            <p style={{ ...benefitStyle, fontSize: 18, marginTop: 6 }} data-testid="wv-mobile-benefit">
              {BENEFIT}
            </p>
            <p style={{ ...mailStyle, fontSize: 12 }} data-testid="wv-mobile-mail">
              {MAIL}
              <span style={footStyle}> {MAIL_FOOT}</span>
            </p>
          </div>
        </section>
      </div>
      </>)}
    </div>
  );
}

const devLabel = {
  textTransform: "uppercase",
  letterSpacing: ".18em",
  fontSize: 11,
  color: "#475569",
  fontWeight: 800,
  margin: "0 0 10px",
};
const kicker = {
  textTransform: "uppercase",
  letterSpacing: ".2em",
  fontSize: 12,
  color: "#0d9488",
  fontWeight: 800,
  margin: 0,
};
const headlineDesk = {
  fontSize: 40,
  lineHeight: 1.1,
  fontWeight: 800,
  color: "#12385f",
  margin: "14px 0 0",
  maxWidth: 900,
  letterSpacing: "-0.01em",
};
const headlineMob = {
  fontSize: 25,
  lineHeight: 1.15,
  fontWeight: 800,
  color: "#12385f",
  margin: "10px 0 0",
  letterSpacing: "-0.01em",
};
const benefitStyle = {
  fontSize: 21,
  fontWeight: 700,
  color: "#12385f",
  margin: 0,
};
const mailStyle = {
  fontSize: 14,
  color: "#64748b",
  margin: "12px 0 0",
  lineHeight: 1.5,
};
const footStyle = { color: "#94a3b8", fontSize: "0.85em" };
